import { useEffect } from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';

const faqJsonLd = (faqs) =>
  JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  }).replace(/</g, '\\u003c');

export const ProductFAQ = ({ name, faqs }) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = faqJsonLd(faqs);
    document.head.appendChild(script);
    return () => script.remove();
  }, [faqs]);
  return (
    <section className="relative py-20 bg-white" data-testid="product-faq-section">
    <div className="max-w-4xl mx-auto px-5 sm:px-8">
      <div className="text-[12px] uppercase tracking-[0.22em] font-semibold text-[#3E5C76]">FAQ</div>
      <h2 className="mt-3 font-serif text-3xl md:text-4xl font-medium tracking-[-0.02em] text-[#0B2545]">
        {name}, answered
      </h2>
      <Accordion type="single" collapsible className="mt-8">
        {faqs.map((f, i) => (
          <AccordionItem key={f.q} value={`pfaq-${i}`} className="border-slate-200">
            <AccordionTrigger
              className="text-left text-[15.5px] font-semibold text-[#0B2545] hover:text-[#3E5C76] hover:no-underline py-5"
              data-testid={`product-faq-question-${i}`}
            >
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-[14.5px] leading-relaxed text-slate-600 pb-5">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
  );
};
